import { CalendarWeekBeginIcon } from './CalendarWeekBeginIcon';

/**
 * author: Simran
 * id 7C244D7F-9332-4C73-AF3D-1DE3F6E365ED
 * name calendar-week-begin
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-week-begin.svg
 * tags
 * - Date / Time 
 */
export const EventWeekBeginIcon = CalendarWeekBeginIcon;
export default EventWeekBeginIcon